<template>
  <div class="container-xxl">
    <div class="row clearfix g-3">
      <div class="col-lg-12">
        <div>
          <div>
            <div class="card mb-2">
              <div class="card-body p-0 mt-3 table-responsive">
                <table class="table table-hover align-middle mb-0 mis_table" style="width:100%">
                  <thead>
                    <tr>
                      <th>COMPANY NAME</th>
                      <th>COMPANY AFM</th>
                      <th>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="companies && companies.length">
                      <tr v-for="company in companies" :key="company.id">
                        <td>{{ company.name }} {{ company.surname.trim() }}</td>
                        <td>{{ company.company_afm }}</td>
                         <td class="text-center align-middle" v-if="customerId && parseInt(company.id) !== parseInt(customerId)">
                            <div class="button-group">
                                                        <div class="icon-wrapper">
                          <button @click="handleConnect(company.id)" class="btn btn-secondary btn-sm text-center">
                            Connect
                          </button></div></div>
                        </td>
                        <td class="text-center text-success" v-else>
                            Connected
                        </td>
                      </tr>
                    </template>

                    <tr v-else>
                      <td colspan="100">No data</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>                         
    </div>
  </div>
</template>

  
  <script>
  import apiClient from '../services/api';
  import Select2 from 'vue3-select2-component';
      import { fetchCompanies, connectToCompany } from '@/services/accountants';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
  import { ref, onMounted, computed } from 'vue';
import { useToast } from 'vue-toastification';

  export default {
    name: 'Days Off Reports',
    components: {
        Select2
    },
    computed: {
    ...mapGetters({
      getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',
       getIsAccountant: 'getIsAccountant',
      getCustomerId: 'getCustomerId'
    }),
    
    
   
    superUser() {
      return this.getSuperUserPermission === 1;
    },
     customerId(){
        console.log('getCustomerId', this.getCustomerId)
      return this.getCustomerId;
    }, 
    },
   
    data() {
      return {
        filterYear: new Date().getFullYear(),
        filterMonth: '',
        select2Settings: {
              allowClear: true,
              placeholder: "Please select"
        },
        selectedUser: null,
        users: [],
        selectedManagerId: null,
        companies: [],
        selectedMonthData: null,
        editingUserId: null,
        editableDaysOff: null,

        years: [
          { value: (new Date().getFullYear() - 1), selected: '' },
          { value: new Date().getFullYear(), selected: 'selected="selected"' }
        ]
      };
    },
    methods: {
      
   async fetchCompaniesData() {
      try {
        const response = await fetchCompanies();
        if (response.data.success) {
          this.companies = response.data.data;
        }
      } catch (error) {
        console.error('Failed to fetch companies:', error);
      }
    },

  formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('el-GR'); // π.χ. 02/01/2025
},

    
     async handleConnect(companyId) {
    const toast = useToast();

    try {
      const response = await connectToCompany(companyId);
      if (response.data?.success) {
              this.fetchCompaniesData();

        toast.success(response.data.message);
        setTimeout(() => {
        this.$router.push('/employees');
      }, 1000);
      } else {
        toast.error(response.data?.message || 'Αποτυχία σύνδεσης.');
      }
    } catch (error) {
      toast.error('Σφάλμα κατά τη σύνδεση.');
      console.error('Connect error:', error);
    }
  },
      
    },
    async mounted() {
      this.fetchCompaniesData();

    }
  };
  </script>
  
  <style scoped>
  /* Add any component-specific styles here */
  </style>
  